import React from 'react';

const ToggleSwitch = ({ checked = false, onChange, className = '' }) => {
  return (
    <button
      className={`w-11 h-6 rounded-full transition-colors relative ${
        checked ? 'bg-blue-500' : 'bg-neutral-300'
      } ${className}`}
      onClick={() => onChange(!checked)}
    >
      <span
        className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white transition-transform ${
          checked ? 'translate-x-5' : ''
        }`}
        style={{ transition: 'transform 0.2s cubic-bezier(.4,0,.2,1)' }}
      />
    </button>
  );
};

export default ToggleSwitch;